import { combineEpics } from 'redux-observable';
import { removePaymentMethodEpic } from './add-payment-method';
import { getAfterActiveEpic } from './get-after-active';
import { getAfterChangeEpic } from './get-after-change';
import { getPaymentMethodsEpic } from './get-payment-methods';
import { addPaymentMethodEpic } from './remove-payment-method';

const paymentEpic = combineEpics(
  getAfterActiveEpic,
  getAfterChangeEpic,
  getPaymentMethodsEpic,
  addPaymentMethodEpic,
  removePaymentMethodEpic
);

export default paymentEpic;
